import { CustodianStatementLink } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";

export const footerTemplate = "UmbFooter";

export const investmentRiskDisclaimer = null;

export const taxLink: CustodianStatementLink = {
  url: "/portal-redirect?portalType=tax",
  target: "_self"
};

export const statementsLink: CustodianStatementLink = {
  url: "/portal-redirect?portalType=estatements",
  target: "_self"
};

export const statementPreferencesLink: CustodianStatementLink = {
  url: "/portal-redirect?portalType=statementpreferences",
  target: "_self"
};

export const displayMyProfileEditMode = true;

export const logoutRedirectUrl = null;

export const faqTemplate = "UmbForms";

export const faqInstructionsTemplate = "";

export const faqLinkAddress = "";

export const displayAdvice = true;

export const displayFaqExternalLinks = false;

export const displayFaqInstructions = false;

export const displayInvestmentsSection = true;

export const displaySettingsLinkedAccounts = true;

export const allowEmailEdit = false;

export const priorYearContributionOption = true;

export const allowReimbursement = true;

export const showPendingReimbursements = false;

export const showAlternateOnboardingCompleteMessage = false;

export const disabledRouteRedirects = {
  [RouteNames.ContributionsEdit]: RouteNames.Contribution,
  [RouteNames.ManagePayrollContributions]: RouteNames.Contribution,
  [RouteNames.ContributionsManageOtherHsaAmounts]: RouteNames.Contribution,
  [RouteNames.ConfirmContribution]: RouteNames.Contribution
};

export const displayCashAccountMfaPopup = false;

export const umbMaximumAddressLineLength = 26;

export const termsUrl = "https://p1.aprimocdn.net/umb/845a0b13-1bfb-4074-b8ae-b06c015b9ba7/TC021_Bend_HSA_New_Account_Packet_021_Original_file.pdf";

export const feeTemplate = "TermsFeeSchedule";

export const quarterlyPaperStatementFee = 1.5;

export const manageHsaCardsInPortal = false;

export const displayPriorYearContributionDisclaimerCopy = false;

export const displayProjectedContributions = true;

export const allowUserToEditContributions = true;

export const displayPdfForESign = true;

export const eSignPdfUrl = "https://p1.aprimocdn.net/umb/c391ecd6-5c0f-47a4-a595-b06d011ba406/HCSESN_Standalone_Healthcare_Services_Esign_Disclosure_and_Consent_Original_file.pdf";

export const displayHealthcareBluebookLink = false;

export const displayFooterLegalSection = true;

export const contactDetailsSetAtBank = false;

export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = true;

export const disablePortalFunctionalityAfterDate = "10/31/2025";

export const displayFdicBanner = true;

export const fdicDisclaimer = "For deposit accounts at UMB Bank, n.a.";